import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getDisabledStyle = (bordered: boolean, Input?: StyledComponent): SerializedStyles => css`
  ${bordered &&
  css`
    border-color: ${Color.Grey200};
    background-color: ${Color.Grey100};
  `}

  ${Input || '&'} {
    &,
    &::placeholder {
      color: ${Color.Grey400};
    }

    &::-moz-placeholder {
      color: ${Color.Grey400};
    }
  }

  &,
  ${Input} {
    cursor: not-allowed;
  }
`
